import React from 'react';
import { Text } from '@components/typography';
import { babyRegistryPageData } from '@data-ts/pages/baby-registry';
import { JoykitColor } from '@components/themes';
import { WrapperSlider, ContentSlider } from './PropsSlider.styles';

const data = babyRegistryPageData.hero;

interface PropsSliderProps {
  eyebrowColor?: JoykitColor;
  textColor?: JoykitColor;
}

export const PropsSlider: React.FC<PropsSliderProps> = ({ eyebrowColor = 'mono7', textColor = 'mono7' }) => {
  return (
    <>
      <Text variant="sectionEyeBrow20" color={eyebrowColor} tagName="h1" marginBottom={5}>
        {data.eyebrow}
      </Text>
      <Text variant="hed72Hero" color={textColor} tagName="span">
        {data.title}
      </Text>
      <WrapperSlider marginBottom={6}>
        <ContentSlider variant="hed72Hero" color={textColor} tagName="div">
          every new arrival.
          <br />
          every moment.
          <br />
          every first giggle.
          <br />
          every adventure.
          <br />
          every snuggle.
          <br />
          every snooze.
          <br />
          every smile.
          <br />
          every goodnight.
          <br />
          life together.
          <br />
          every new arrival.
        </ContentSlider>
      </WrapperSlider>
    </>
  );
};
